<script>
import options from './NewCarLoanCalculatorAdjustLoan.options'
export default options
</script>

<template>
    <article class="nyk-new-car-loan-calculator-adjust-loan">
        <div class="nyk-new-car-loan-calculator-adjust-loan__container">
            <div class="nyk-new-car-loan-calculator-adjust-loan__container--header">
                <h2 class="nyk-new-car-loan-calculator-adjust-loan__container--header-title">
                    Tilpas beregning
                </h2>
                <button
                    v-on:click="onCloseCallback"
                    class="nyk-new-car-loan-calculator-adjust-loan--close-button">
                    <span class="nyk-icon nyk-icon--ui-close"></span>
                </button>
            </div>
            <NewCarLoanCalculatorInputs
                :labelsInput="labelsInput"
                :labelsError="labelsError"
                :optionsInput="optionsInput"
                :displayErrors="displayErrors"
                :onChangeCallback="onChangeCallback"/>
        </div>
    </article>
</template>